module.exports = __webpack_public_path__ + "static/img/12.a398ea3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/sp/12.png
// module id = y/8a
// module chunks = 0